const TOGGLE_SELECTED = 'PAYPAL_TOGGLE_SELECTED';
const SET_READY = 'PAYPAL_SET_READY';
const SHOW_ERROR = 'PAYPAL_SHOW_ERROR';
const RESET_ERROR = 'PAYPAL_RESET_ERROR';

export {
    TOGGLE_SELECTED, SET_READY, SHOW_ERROR, RESET_ERROR
};
